import assetPath from '/app/packages/lebenslauf/articles/src/assets/bewerbung-zurueckziehen-eine-entscheidung-mit-fingerspitzengefuehl.jpg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')